import { Skeleton } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const ProductsRow = styled.div`
    display: flex;
    gap: ${getPurpurSpacing('50')};
    margin-bottom: ${getPurpurSpacing('200')};

    ${purpurMedia('lg')`
        margin-bottom: ${getPurpurSpacing('400')};
        gap: ${getPurpurSpacing('300')};
    `};
`;

export const ProductColumn = styled.div`
    flex: 1;
    height: 11rem;

    &:last-child {
        display: none;
    }

    ${purpurMedia('lg')`
        height: 27rem;
        &:last-child {
            display: block;
        }
    `};
`;

export const SpacerColumn = styled(ProductColumn)`
    display: none;
    ${purpurMedia('xl')`
        display: block;
    `};
`;

export const ProductSkeleton = styled(Skeleton)`
    width: 100%;
    height: 100%;
`;

export const FeaturesContainer = styled.div`
    margin-bottom: ${getPurpurSpacing('800')};
`;
